import { lazy, Suspense } from "react";
import { PageSkeleton } from "../../../customs/skeleton/main";

const Main = lazy(() => import("../../../components/settings/learningTraining/eventDetails/main"));

const EventDetails = () => {
  return (
        <Suspense fallback={<PageSkeleton />}>
          <Main />
        </Suspense>
      
  );
};

export default EventDetails;

